import isEmpty from 'lodash/isEmpty'

export const processUser = customer => {
   const sub = {}
   const { brandCustomers = [], ...rest } = customer

   let brand_customer
   if (!isEmpty(brandCustomers)) {
      ;[brand_customer] = brandCustomers
      const addresses = brand_customer.addresses.map(
         address => address.customerAddress
      )
      const {
         id,
         isDemo = false,
         subscription = null,
         subscriptionId = null,
         subscriptionAddressId = null,
         subscriptionPaymentMethodId = null,
         isSubscriptionCancelled = null,
         subscriptionOnboardStatus = 'REGISTER',
         pausePeriod = null,
      } = brand_customer

      rest.isDemo = isDemo
      rest.brandCustomerId = id
      rest.pausePeriod = pausePeriod
      rest.subscription = subscription
      rest.subscriptionId = subscriptionId
      rest.subscriptionAddressId = subscriptionAddressId
      rest.isSubscriptionCancelled = isSubscriptionCancelled
      rest.subscriptionPaymentMethodId = subscriptionPaymentMethodId
      rest.subscriptionOnboardStatus = subscriptionOnboardStatus
      brand_customer.addresses = addresses

      sub.defaultPaymentMethodId =
         rest?.platform_customer?.defaultPaymentMethodId || null
      sub.defaultAddress = brand_customer?.addresses.find(
         address => address?.id === subscriptionAddressId
      )
   }
   return {
      ...rest,
      ...sub,
      brandCustomers: brand_customer,
      isSubscriber: brand_customer?.isSubscriber,
   }
}
